import { DataBean } from "../../DataBean";


export class HealthAttentionSite extends DataBean {


    public async getHealthAttentionSiteCatalog(idState:any,regexStr:any,page:any,recordsPerPage:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getHealthAttentionSiteCatalog_Number_String_Number_Number", [idState,regexStr,page,recordsPerPage]);
    }


}